import React, { useCallback } from 'react';

import MenuButton from 'monday-ui-react-core/dist/MenuButton';
import Menu from 'monday-ui-react-core/dist/Menu';
import MenuItem from 'monday-ui-react-core/dist/MenuItem';

import { adjustments } from '../../../../../constants';
import { v4 as uuid } from 'uuid';
import { bigBrainTrack } from '../../../../../services/bigbrain-service';
import bigBrainEvents from '../../../../../constants/bigbrain-events';
import { useMondayContext } from '../../../../../contexts/monday-context';

import './adjustment-menu-component.scss';

const { DISCOUNT_ADJUSTMENT, TAX_ADJUSTMENT, FEE_ADJUSTMENT } = adjustments;

export default function AdjustmentMenuComponent({ taxLabel, feeLabel, onAdjustmentAdd }) {
  const { mondayContext = {} } = useMondayContext();
  const { boardId, itemId } = mondayContext;

  const onMenuOptionClicked = useCallback(
    ({ condition, type, title }) => {
      const rate = {
        id: uuid(),
        condition,
        type,
        title,
        valueType: 'percents',
      };

      bigBrainTrack(bigBrainEvents.ADJUSTMENTS.ADD_NEW, {
        kind: type,
        info1: boardId,
        info2: itemId,
      });

      onAdjustmentAdd(rate);
    },
    [onAdjustmentAdd, boardId, itemId]
  );

  const renderMenuButtonLabel = () => {
    return (
      <div className="adjustments-menu-button-label">
        <span>+ Add adjustment</span>
      </div>
    );
  };

  return (
    <div className="adjustment-menu-component">
      <MenuButton
        dialogPaddingSize="small"
        component={renderMenuButtonLabel}
        componentClassName="adjustments-menu-wrapper"
        closeDialogOnContentClick
      >
        <div className="adjustments-menu-content">
          <Menu>
            <MenuItem title="Add discount" onClick={() => onMenuOptionClicked(DISCOUNT_ADJUSTMENT)} />
            <MenuItem
              title={`Add ${taxLabel}`}
              onClick={() => onMenuOptionClicked({ ...TAX_ADJUSTMENT, title: taxLabel })}
            />
            <MenuItem
              title={`Add ${feeLabel}`}
              onClick={() => onMenuOptionClicked({ ...FEE_ADJUSTMENT, title: feeLabel })}
            />
          </Menu>
        </div>
      </MenuButton>
    </div>
  );
}
